import * as React from 'react';
import { ApplicationContext } from '../../components/ApplicationContext';
import { IApplicationContext } from '../../types/applicationContext';

export function withContext<T extends IApplicationContext>(
  WrappedComponent: React.ComponentType<Omit<T, keyof IApplicationContext>>,
) {
  // eslint-disable-next-line react/display-name
  return ({
    httpApi,
    logger,
    config,
    telemetry,
    servicePickerWidgetMicrofrontend,
    paymentWidgetMicrofrontend,
    ...props
  }: T) => {
    const context = React.useMemo(() => ({ httpApi, logger, config, telemetry }), [httpApi, logger, config, telemetry]);

    return (
      <ApplicationContext.Provider value={context}>
        <WrappedComponent {...props} />
      </ApplicationContext.Provider>
    );
  };
}
